<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-18 21:16:52
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-13 09:27:57
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="machine-info">
        <table class="table-info" width="100%" cellspacing="0">
          <tr>
            <td width="11%" class="title">姓名</td>
            <td width="25%" class="info">{{ detail.personName }}</td>
            <td width="11%" class="title">性别</td>
            <td width="25%" class="info">{{ detail.sex | formatSex }}</td>
            <td width="11%" class="title">出生日期</td>
            <td width="25%" class="info">{{ detail.birthDay }}</td>
          </tr>
          <tr>
            <td width="11%" class="title">年龄</td>
            <td width="25%" class="info">{{ detail.personAge }}</td>
            <td width="11%" class="title">身份证号</td>
            <td width="25%" class="info">{{ detail.idCard }}</td>
            <td width="11%" class="title">所在村组</td>
            <td width="25%" class="info">{{ detail.villGropName }}</td>
          </tr>
          <tr>
            <td width="11%" class="title">手机号</td>
            <td width="25%" class="info">{{ detail.mobile }}</td>
            <td width="11%" class="title">住址</td>
            <td width="25%" class="info">{{ detail.address }}</td>
            <td width="11%" class="title">是否户主</td>
            <td width="25%" class="info">
              {{ detail.isHolder | formatIsHolder }}
            </td>
          </tr>
        </table>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="家庭成员" name="first"
          ><FamilyMembers v-if="isRequest" :list="detail.family"></FamilyMembers
        ></el-tab-pane>
        <el-tab-pane label="土地信息" name="second"
          ><FamilyLand
            v-if="isRequest"
            :landList="detail.tLandDtoList"
          ></FamilyLand
        ></el-tab-pane>
        <el-tab-pane label="工作经历" name="third"></el-tab-pane>
        <el-tab-pane label="专业技能" name="fourth"></el-tab-pane>
      </el-tabs>
    </div>
  </el-main>
</template>

<script>
import FamilyMembers from "./components/FamilyMembers";
import FamilyLand from "./components/FamilyLand";
export default {
  name: "ResourceHumanDetail",
  components: {
    FamilyMembers,
    FamilyLand,
  },
  data() {
    return {
      id: "",
      detail: {},
      isRequest: false,
      activeName: "first",
    };
  },
  filters: {
    formatSex(value) {
      let result = "";
      switch (value) {
        case 1:
          result = "男";
          break;
        case 0:
          result = "女";
          break;
      }
      return result;
    },
    formatIsHolder(value) {
      let result = "";
      switch (value) {
        case 1:
          result = "是";
          break;
        case 0:
          result = "否";
          break;
      }
      return result;
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getVillPersonDetail();
  },
  methods: {
    /**
     * @descripttion: 获取村民详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     * @param {*}
     */
    getVillPersonDetail() {
      this.$http.village.getVillPersonDetail({ id: this.id }).then((res) => {
        this.detail = res.data;
        this.isRequest = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.main {
  .machine-info {
    display: flex;
    .table-info {
      &:first-child {
        margin-right: 10px;
      }
      .machine {
        width: 150px;
        height: 120px;
      }
      .qr-code {
        width: 108px;
        height: 118px;
      }
      .el-image {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
